import axios from '@/plugins/axios'

/**
 * Create creatives
 */
const createCreative = async (form) => {
  try {
    const formData = new FormData()
    formData.append('advertiser_id', form.advertiser_id)
    formData.append('format', form.format)

    // Adiciona cada criativo como um array no FormData
    form.creatives.forEach((creative, index) => {
      formData.append(`creatives[${index}][name]`, creative.name)
      formData.append(`creatives[${index}][url]`, creative.url)
      formData.append(`creatives[${index}][file]`, creative.file)
      formData.append(`creatives[${index}][layout]`, creative.layout)
      formData.append('is_desktop', creative.is_desktop ? 1 : 0)
      formData.append('is_mobile', creative.is_mobile ? 1 : 0)
      formData.append('is_app', creative.is_app ? 1 : 0)
      formData.append(`creatives[${index}][total_chunks]`, creative.total_chunks)

      if (creative.banner) formData.append(`creatives[${index}][banner]`, creative.banner)
      formData.append(`creatives[${index}][companion_creative_id]`, creative.companion_creative_id ?? '')

      if (creative.logo) formData.append(`creatives[${index}][logo]`, creative.logo)
      if (creative.headline) formData.append(`creatives[${index}][headline]`, creative.headline)
      if (creative.body_text) formData.append(`creatives[${index}][body_text]`, creative.body_text)
      if (creative.call_to_action) formData.append(`creatives[${index}][call_to_action]`, creative.call_to_action)
      if (creative.advertiser_display_name) formData.append(`creatives[${index}][advertiser_display_name]`, creative.advertiser_display_name)
      if (creative.caption_url) formData.append(`creatives[${index}][caption_url]`, creative.caption_url)
      if (creative.youtube_url) formData.append(`creatives[${index}][youtube_url]`, creative.youtube_url)
    })

    const response = await axios.post('creatives', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get creatives
 */
const getCreatives = async ({
  advertiserId,
  format = '',
  page = 1,
  search = '',
  layout = '',
  // eslint-disable-next-line camelcase
  approved_status = ''
}) => {
  try {
    const params = {
      advertiser_id: advertiserId,
      page: page,
      search: search
    }
    if (format) params.format = format
    if (layout) params.layout = layout
    // eslint-disable-next-line camelcase
    if (approved_status) params.approved_status = approved_status
    const response = await axios('creatives', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * upload file chunk
 */
const uploadFileChunk = async ({ fileId, chunk, chunkIndex, totalChunks, fileName }) => {
  try {
    const formData = new FormData()
    formData.append('file', chunk)
    formData.append('file_id', fileId)
    formData.append('chunk_index', chunkIndex)
    formData.append('total_chunks', totalChunks)
    formData.append('file_name', fileName)

    const response = await axios.post('/file-chunks', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Retry creation on platform
 */
const retryCreationOnPlatform = async id => {
  try {
    const response = await axios.post(`creatives/${id}/retry`, {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update creative
 */
const updateCreative = async (id, form) => {
  try {
    const formData = new FormData()
    formData.append('advertiser_id', form.advertiser_id)

    form.creatives.forEach((creative, index) => {
      formData.append('_method', 'PUT')
      formData.append(`creatives[${index}][layout]`, creative.layout)
      if (creative.name) formData.append(`creatives[${index}][name]`, creative.name)
      if (creative.url) formData.append(`creatives[${index}][url]`, creative.url)
      if (creative.file) formData.append(`creatives[${index}][file]`, creative.file)
      formData.append(`creatives[${index}][layout]`, creative.layout)
      // eslint-disable-next-line camelcase
      formData.append(`creatives[${index}][is_desktop]`, creative.is_desktop ? 1 : 0)
      // eslint-disable-next-line camelcase
      formData.append(`creatives[${index}][is_mobile]`, creative.is_mobile ? 1 : 0)
      // eslint-disable-next-line camelcase
      formData.append(`creatives[${index}][is_app]`, creative.is_app ? 1 : 0)

      if (creative.banner) formData.append(`creatives[${index}][banner]`, creative.banner)
      else formData.append(`creatives[${index}][companion_creative_id]`, creative.companion_creative_id ?? '')

      if (creative.logo) formData.append(`creatives[${index}][logo]`, creative.logo)
      if (creative.headline) formData.append(`creatives[${index}][headline]`, creative.headline)
      // eslint-disable-next-line camelcase
      if (creative.body_text) formData.append(`creatives[${index}][body_text]`, creative.body_text)
      // eslint-disable-next-line camelcase
      if (creative.call_to_action) formData.append(`creatives[${index}][call_to_action]`, creative.call_to_action)
      // eslint-disable-next-line camelcase
      if (creative.advertiser_display_name) formData.append(`creatives[${index}][advertiser_display_name]`, creative.advertiser_display_name)
      // eslint-disable-next-line camelcase
      if (creative.caption_url) formData.append(`creatives[${index}][caption_url]`, creative.caption_url)
    })

    const response = await axios.post(`creatives/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  createCreative,
  getCreatives,
  uploadFileChunk,
  retryCreationOnPlatform,
  updateCreative
}
